import { useCallback, useMemo } from 'react';
import { useUserSession } from './useDefaultSession';

/**
 * TODO: Need to match this to the Servers Roles (Dev Environment has different roles that do not much the Seeded DB's )
 */
export enum Roles {
    Adult = 'adult',
    Child = 'child',
}

export enum Permissions {
    manage_profile = 'manage_profile',
    notification_settings = 'notification_settings',
    google_drive = 'google_drive',
    dropbox = 'dropbox',
    planner_day = 'planner_day',
    planner_week = 'planner_week',
    planner_month = 'planner_month',
    planner_schedule = 'planner_schedule',
    planner_grid = 'planner_grid',
    planner_flow = 'planner_flow',
    planner_boards = 'planner_boards',
    calendar_sync = 'calendar_sync',
    personal_calendar_add = 'personal_calendar_add',
    family_calendar_add = 'family_calendar_add',
    edit_profile_picture = 'edit_profile_picture',
    join_course = 'join_course',
    skipper_community = 'skipper_community',
}

/**
 * Helper functions returning the users session and checking against permissions
 * and also used to validate an accounts roles
 *
 * @returns
 */
export function useUserPermissions() {
    const [user] = useUserSession();

    const hasPermission = useCallback(
        (permCheck: string) => {
            const permissions = user?.permissionLevel?.permissions ?? [];
            if (!permissions) return false;
            const permissionsSet = new Set(permissions);

            return permissionsSet.has(permCheck);
        },
        [user],
    );

    const atleastOne = useCallback(
        (permsArray: string[]) => {
            const permissions = user?.permissionLevel?.permissions ?? [];
            if (!permissions) return false;
            const permissionsSet = new Set(permissions);
            for (let i = 0; i < permsArray.length; i++) {
                const perm = permsArray[i];
                if (permissionsSet.has(perm)) {
                    return true;
                }
            }
            return false;
        },
        [user],
    );

    const hasRole = useCallback(
        (role: string) => {
            if (!user?.accountRole) {
                return false;
            }

            return user?.accountRole?.roleType === role;
        },
        [user],
    );

    /**
     * TODO: Temporary to just make sure the user is not a child.
     * Once roles are defined we should extend the correct permissions to roles accordingly
     */
    const notChild = useMemo(() => {
        if (!user?.accountRole) {
            return false;
        }

        return user?.accountRole?.roleType !== 'child';
    }, [user]);

    return { hasPermission, atleastOne, hasRole, notChild, user };
}
